export const LOAD_COURSEWARE_ITEM = 'LOAD_COURSEWARE_ITEM';
export const SET_COURSEWARE_ITEM = 'SET_COURSEWARE_ITEM';
export const SET_IN_COURSEWARE_ITEM = 'SET_IN_COURSEWARE_ITEM';
export const PROMPT_CREATE_COURSEWARE_ITEM = 'PROMPT_CREATE_COURSEWARE_ITEM';
export const CREATE_COURSEWARE_ITEM = 'CREATE_COURSEWARE_ITEM';
export const OPEN_COURSEWARE_ITEM = 'OPEN_COURSEWARE_ITEM';
export const SET_CONFIGURATION = 'SET_CONFIGURATION';
export const SET_IN_CONFIGURATION = 'SET_IN_CONFIGURATION';
